import { useEffect, useState } from "react";
import { Loader2, Power, ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export function EsKillSwitch() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/superadmin/es/kill-switch").then((r) => setSt(r.data)).catch(() => setSt(null));
  useEffect(() => { load(); }, []);
  const toggle = async () => {
    const next = !st.disabled;
    const reason = next ? window.prompt("Motivo della disattivazione immediata (registrato):", "") : "riattivazione";
    if (next && reason === null) return;
    if (!window.confirm(next ? "Spegnere SUBITO l'Embedded Signup per tutti i clienti? Il pulsante «Collega WhatsApp» verrà disabilitato." : "Riattivare l'Embedded Signup?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/superadmin/es/kill-switch", { disabled: next, reason });
      setSt(data); toast.success(next ? "Embedded Signup disattivato" : "Embedded Signup riattivato");
    } catch (e) { toast.error(e.response?.data?.detail || "Operazione non riuscita"); } finally { setBusy(false); }
  };
  if (!st) return null;
  return (
    <div className={`rounded-xl border p-4 flex flex-wrap items-center gap-3 ${st.disabled ? "border-red-200 bg-red-50" : "border-slate-200 bg-white"}`} data-testid="sa-es-kill-switch">
      <ShieldAlert className={`h-4 w-4 ${st.disabled ? "text-red-600" : "text-slate-500"}`} />
      <div className="text-sm">
        <p className="font-semibold text-slate-800">Embedded Signup — interruttore di emergenza</p>
        <p className="text-xs text-slate-600" data-testid="sa-es-kill-state">
          {st.disabled ? `DISATTIVATO${st.reason ? ` · ${st.reason}` : ""}${st.by ? ` · ${st.by}` : ""}` : "Attivo"} · flag ambiente {st.flag_env ? "ON" : "OFF"} · tenant abilitati: {st.pilots.length ? st.pilots.join(", ") : "nessuno"}
        </p>
      </div>
      <Button size="sm" disabled={busy} onClick={toggle} className={`ml-auto h-8 text-xs text-white ${st.disabled ? "bg-emerald-600 hover:bg-emerald-700" : "bg-red-600 hover:bg-red-700"}`} data-testid="sa-es-kill-toggle">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><Power className="h-3.5 w-3.5 mr-1" />{st.disabled ? "Riattiva Embedded Signup" : "Disattiva subito"}</>}
      </Button>
    </div>
  );
}
